export default __webpack_public_path__ + "static/media/orange.1c471eef.svg";